import { SelectProps } from 'antd'
import { Select } from 'components/atoms'
import { GENDER_OPTIONS } from 'constants/options'
import { useUtil } from 'hooks'
import { useTranslation } from 'react-i18next'

interface IProps extends SelectProps<any, any> {
  title?: string
  placeholder?: string
  preventInput?: boolean
}

const SelectGender = (props: IProps) => {
  const { title = '', placeholder = '', ...resProps } = props
  const { t } = useTranslation()
  const { getOptions } = useUtil()
  return (
    <Select
      showArrow
      allowClear
      title={t(title || 'gender')}
      placeholder={t(placeholder)}
      options={getOptions(GENDER_OPTIONS)}
      filterOption={false}
      {...resProps}
    />
  )
}

export default SelectGender
